import {call, put, takeEvery} from 'redux-saga/effects';
import MyOverallHighlightsApi from '../../api/MyOverallHighlightsApi';
import myOverallHighlightsActions from '../../actions/fortnite-game/myOverallHighlights.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getHighlights(action) {
    try {
        const {data} = yield call(MyOverallHighlightsApi.getHighlights, action.payload);
        yield put(
            myOverallHighlightsActions.getHighlightsSuccess({
                data,
                error: data.length ? undefined : NO_DATA_ERROR_CODE,
                ...action.payload
            })
        );
    } catch (e) {
        yield put(
            myOverallHighlightsActions.getHighlightsFailed(getErrorCodeFromResponse(e), {
                ...action.payload,
                ...e
            })
        );
    }
}

function* myOverallHighlightsSaga() {
    yield takeEvery(myOverallHighlightsActions.TYPES.GET_HIGHLIGHTS, getHighlights);
}

export default myOverallHighlightsSaga;
